export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    tableData: Array,
    // eslint-disable-next-line vue/require-default-prop
    pageConfig: Object
  },
  data() {
    return {
      tableHeight: '251px',
      queryData: {
        invoiceCode: '',
        invoiceNum: ''
      }
    }
  },
  mounted() {
  },
  created() {
  },
  methods: {
    preview(row) {
      const a = document.createElement('a')
      const event = new MouseEvent('click')
      a.target = '_blank'
      a.href = 'https://www.wzyb.com.cn/pmpFile' + row.filePath
      a.dispatchEvent(event)
    },
    handleSizeChange(val) {
      this.$emit('handleSizeChange', val)
    },
    handleCurrentChange(val) {
      this.$emit('handleCurrentChange', val)
    }

  }

}
